import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';

import Routes from "../../routes";
import AccessDenied from "./accessDenied.js";

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column', 
  },
});

class Main extends Component {
  render() {
    const { classes, accessDenied, isAuthenticated, isAuthenticating } = this.props;
    return (
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {accessDenied && <AccessDenied />}
        {(!accessDenied && !isAuthenticating) && <Routes isAuthenticated={isAuthenticated} />}
      </main>
    );
  }
}

export default withStyles(styles)(Main);
